/**
 * schemas actions
 */
import {
    SET_SCHEMA,
    ENABLE_SCHEMA,
    ENABLE_SCHEMA_SUCCEEDED,
    SET_SCHEMA_ENABLED,
    ENABLE_SCHEMA_ERROR,
    DISABLE_SCHEMA,
    DISABLE_SCHEMA_SUCCEEDED,
    SET_SCHEMA_DISABLED,
    DISABLE_SCHEMA_ERROR
} from './constants';

export function setSchema(schemaId, data) {
    return {
        type: SET_SCHEMA,
        payload: {
            schemaId,
            data
        }
    };
}

export function enableSchema(schemaId) {
    return {
        type: ENABLE_SCHEMA,
        payload: {
            schemaId
        },
        meta: {
            logentries: true
        }
    };
}

export function schemaEnabled(response) {
    return {
        type: ENABLE_SCHEMA_SUCCEEDED,
        payload: response
    };
}

export function setSchemaEnabled(schemaId) {
    return {
        type: SET_SCHEMA_ENABLED,
        payload: {
            schemaId
        }
    };
}

export function schemaEnablingError(error) {
    return {
        type: ENABLE_SCHEMA_ERROR,
        payload: error,
        error: true
    };
}

export function disableSchema(schemaId) {
    return {
        type: DISABLE_SCHEMA,
        payload: {
            schemaId
        },
        meta: {
            logentries: true
        }
    };
}

export function schemaDisabled(response) {
    return {
        type: DISABLE_SCHEMA_SUCCEEDED,
        payload: response
    };
}

export function setSchemaDisabled(schemaId) {
    return {
        type: SET_SCHEMA_DISABLED,
        payload: {
            schemaId
        }
    };
}

export function schemaDisablingError(error) {
    return {
        type: DISABLE_SCHEMA_ERROR,
        payload: error,
        error: true
    };
}
